var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMirLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 16,
    viewBox: "0 0 54 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 0H37.7C38.3 3.4 41.6 6.60001 45.2 6.60001H53.4C53.5 6.30001 53.5 5.8 53.5 5.5C53.5 2.5 51 0 48 0Z",
    fill: "url(#paint0_linear_1_3)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6 7.20001V15.5H43.6V11.1H48C50.4 11.1 52.5 9.40001 53.2 7.20001H38.6Z",
    fill: "#4FAD50"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 0V15.4H25.4C25.4 15.4 26.5 15.4 27.1 14.3C30.1 8.4 31 6.60001 31 6.60001H31.6V15.4H36.6V0H32.2C32.2 0 31.1 0.100006 30.5 1.10001C28 6.20001 26.6 8.8 26.6 8.8H26V0H21Z",
    fill: "#4FAD50"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 15.5V0.100006H5C5 0.100006 6.40001 0.100003 7.20001 2.3C9.20001 8.1 9.40002 8.90001 9.40002 8.90001C9.40002 8.90001 9.80001 7.5 11.6 2.3C12.4 0.100003 13.8 0.100006 13.8 0.100006H18.8V15.5H13.8V7.20001H13.2L10.4 15.5H8.20001L5.40002 7.20001H4.80002V15.5H0Z",
    fill: "#4FAD50"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_3",
    x1: 37.6822,
    y1: 3.3473,
    x2: 53.4646,
    y2: 3.3473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#27B1E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#148ACA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMirLogo);
export default __webpack_public_path__ + "static/media/MirLogo.cbb9de73fdec209aac8fd888eaf1c448.svg";
export { ForwardRef as ReactComponent };